<template>
  <div class="work-form-container">
    <el-card title="添加作品">
      <el-form ref="workForm" :model="workForm" :rules="rules" label-width="100px">
        <!-- 作品名称 -->
        <el-form-item label="作品名称" prop="name">
          <el-input v-model="workForm.name" placeholder="请输入作品名称"></el-input>
        </el-form-item>
        
        <!-- 作品描述 -->
        <el-form-item label="作品描述" prop="description">
          <el-input 
            v-model="workForm.description" 
            placeholder="请输入作品描述" 
            type="textarea" 
            rows="4">
          </el-input>
        </el-form-item>
        
        <!-- 图片上传 -->
        <el-form-item label="作品图片">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"  
            :on-success="handleImageUploadSuccess"
            :on-error="handleImageUploadError"
            :before-upload="beforeUpload"
            :show-file-list="true"
            :auto-upload="true"
            accept="image/jpeg,image/png"
            :limit="1">
            <el-button size="small" type="primary">点击上传图片</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过2MB
            </div>
          </el-upload>
          
          <!-- 本地预览 -->
          <el-image 
            v-if="workForm.imageUrl" 
            :src="workForm.imageUrl" 
            style="width: 150px; height: auto; margin-top: 10px"
            fit="contain">
          </el-image>
        </el-form-item>
        
        <!-- 表单操作按钮 -->
        <el-form-item>
          <el-button @click="resetForm">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitting">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createWork } from '@/api/work';
// import { uploadImage } from '@/api/upload';

export default {
  data() {
    return {
      workForm: {
        name: '',
        description: '',
        imageUrl: ''
      },
      // 修复上传URL
      uploadUrl: process.env.VUE_APP_BASE_API 
        ? `${process.env.VUE_APP_BASE_API}/upload/image` 
        : '/api/upload/image',  // 提供默认值
      rules: {
        // 表单规则保持不变
      },
      submitting: false
    };
  },
  methods: {
    // 图片上传成功处理
    handleImageUploadSuccess(response) {
      console.log('开始上传图片11', response);
      console.log('图片上传成功', response);
      if (response && response.data && response.data.url) {
        this.workForm.imageUrl = response.data.url;
        this.$message.success('图片上传成功');
      } else {
        this.$message.error('图片上传失败: 无效的响应格式');
      }
    },
    
    // 图片上传失败处理
    handleImageUploadError(error) {
      console.error('图片上传失败', error);
      this.$message.error('图片上传失败，请重试');
    },
    
    // 上传前检查
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传JPG/PNG格式的图片');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB');
        return false;
      }
      
      this.uploadLoading = true;
      return true;
    },
    
    // 表单提交 - 仅提交JSON数据
    async submitForm() {
      this.$refs.workForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true;
          try {
            // 提交JSON格式的作品数据（包含图片URL）
            const response = await createWork(this.workForm);
            console.log('作品创建成功', response);
            
            this.$message.success('作品创建成功');
            this.$router.push('/works');
          } catch (error) {
            console.error('作品创建失败', error);
            this.$message.error(`创建失败: ${error.message || '未知错误'}`);
          } finally {
            this.submitting = false;
          }
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.$refs.workForm.resetFields();
      this.$router.go(-1);
    }
  }
};
</script>